import {FC} from 'react'

import {GuideContentLayout} from '@/components/guide/GuideContentLayout'
import {getBrandMonitoringGuideContent} from '@/content/brand-monitoring/brandMonitoringGuide'
import {brandMonitoringPlatforms} from '@/content/brand-monitoring/constants'
import {useTranslation} from '@/i18n'
import {BrandSubscriptionPlatform} from '@/utils/brand-subscription/constants'
import {BrandProtectionGuideContent} from '@/utils/contentful'
import {useNavigation} from '@/utils/hooks/useNavigation'
import {routeTo} from '@/utils/router'

type BrandProtectionGuideContentLayoutProps = {
  brandProtectionGuide: BrandProtectionGuideContent
}

export const BrandProtectionGuideContentLayout: FC<BrandProtectionGuideContentLayoutProps> = ({
  brandProtectionGuide,
}) => {
  const {t} = useTranslation()
  const {learnMoreText, registrationCard} = getBrandMonitoringGuideContent()
  const {platformKey, guide, platformCardTitle, platformCardDescription} = brandProtectionGuide

  const {route} = useNavigation()

  const trademarkRegistrationCard = {
    title: t(registrationCard.title),
    description: t(registrationCard.description),
    imageSrc: registrationCard.imageSrc,
    imageAlt: registrationCard.imageAlt,
    buttonText: t(learnMoreText),
    buttonLink: routeTo.verification.form(),
    trackedEvent: {name: 'Trademark registration', parameters: {pageName: route}},
  }

  const getPlatformCard = () => {
    const platformData = brandMonitoringPlatforms[platformKey as BrandSubscriptionPlatform]

    return {
      title: platformCardTitle,
      description: platformCardDescription,
      buttonText: t(learnMoreText),
      ...(platformData && platformData.slug
        ? {
            imageSrc: platformData.imageSrc,
            imageAlt: platformData.imageAlt,
            buttonLink: routeTo.brandMonitoring.platform(platformData.slug),
            trackedEvent: {
              name: 'Brand monitoring platform page',
              parameters: {pageName: route, platform: platformKey},
            },
          }
        : {
            imageSrc: '/images/icons/binoculars.svg',
            imageAlt: 'Binoculars',
            buttonLink: routeTo.brandMonitoring.home(),
            trackedEvent: {
              name: 'Brand monitoring page',
              parameters: {pageName: route, platform: platformKey},
            },
          }),
    }
  }

  return (
    <GuideContentLayout
      guide={guide}
      sidebarCards={[getPlatformCard(), trademarkRegistrationCard]}
    />
  )
}
